import axios from 'axios';
import Router from 'vue-router';
import login from './login';
import customers from './customers';
import customersEdit from './customers-edit';
import customersNew from './customers-new';
import accountDefinitions from './account-definitions';
import companies from './companies';
import companiesNew from './companies-new';
import companiesEdit from './companies-edit';
import accountant from './accounting-plans';
import rules from './rules';
import accountingParametrization from './accounting-parametrization';
import accountingPeriods from './accounting-periods';
import accountingRulesNew from './accounting-rules-new';
import modules from './modules';
import accountingAccounts from './accounting-accounts';
import dictionary from './dictionary';
import costCenters from './cost-centers';
import accountingRulesEdit from './accounting-rules-edit';
import journal from './journal';
import records from './records';
import recordsDetail from './records-detail';
import ledger from './ledger';
import components from './components';
import accountingAccountsBySubsidiary from './accounting-accounts-by-subsidiary';
import accountingAction from './accouting-action';
import newCostCenters from './new-cost-center';
import editAccounting from './edit-accounting';
import main from './main';
import statistics from './statistics';
import reports from './reports';
import templates from './company-templates';
import atsSales from './ats-sales';
import atsRules from './ats-rules';
import atsRulesNew from './ats-rules-new';
import rulesAtsEdit from './rules-ats-edit';
import atsListDictionary from './ats-list-dictionary';
import atsDictionary from './ats-dictionary';
import atsDefinitions from './ats-definitions';
import batchAccounting from './batch-accounting';
import accountingAnalysis from './accounting-analysis';
import syncOdoo from './sync-odoo';

export default function (Vue) {
	Vue.use(Router);
	Vue.use(axios);
	const config = new Router({
		mode: 'history',
		routes: [
			{
				path: '/',
				name: 'page-home',
				redirect: '/main',
				children: [
					atsListDictionary,
					atsDictionary,
					atsDefinitions,
					accountant,
					accountingAction,
					accountingAccounts,
					accountingParametrization,
					accountingPeriods,
					accountingRulesNew,
					customers,
					customersEdit,
					customersNew,
					dictionary,
					accountDefinitions,
					companies,
					companiesNew,
					companiesEdit,
					modules,
					rules,
					costCenters,
					accountingRulesEdit,
					journal,
					records,
					recordsDetail,
					ledger,
					accountingAccountsBySubsidiary,
					newCostCenters,
					editAccounting,
					main,
					statistics,
					reports,
					templates,
					atsRules,
					atsSales,
					atsRulesNew,
					rulesAtsEdit,
					batchAccounting,
					accountingAnalysis,
					syncOdoo,
				],
				component: () => import('@/pages/page-home'),
			},
			login,
			components,
		],
	});
	config.beforeEach(async (to, from, next) => {
		if (to.name !== 'login') {
			if (to.query && to.query.email && to.query.password) {
				/* localStorage.setItem(`${process.env.STORAGE_USER_KEY}::token`, to.query.token); */
				const userData = {
					email: to.query.email,
					password: to.query.password,
					codeApp: process.env.APP_CODE,
				};
				try {
					const response = await axios.post('https://ec-acl.makipos.la/api/authenticate', userData);
					const user = response.data;
					const inLocalStorage = JSON.stringify(user);
					const { token, codeProject } = user;
					localStorage.setItem(process.env.STORAGE_USER_KEY, inLocalStorage);
					localStorage.setItem(`${process.env.STORAGE_USER_KEY}::codeProject`, codeProject);
					localStorage.setItem(`${process.env.STORAGE_USER_KEY}::token`, token);
					// this.$store.dispatch('setUser', token);
					const headers = {
						Authorization: `Bearer ${token}`,
					};
					const { data: current } = await axios.get('https://ec-motor.makipos.la/company-token', { headers });
					const currentInLocalStorage = JSON.stringify(current);
					localStorage.setItem(`${process.env.STORAGE_USER_KEY}::adminUser`, currentInLocalStorage);
					this.$router.push({ name: 'main' });
				} catch (e) {
					// eslint-disable-next-line
					console.error(e);
				}
			}
			const token = window.localStorage.getItem(`${process.env.STORAGE_USER_KEY}::token`);
			if (token) {
				return next();
			}
			return next({ name: 'login' });
		}
		return next();
	});
	return config;
}



// WEBPACK FOOTER //
// ./src/router/index.js